export enum MultiLineValueTypes {
	NUMBER = 'number',
	TEXT = 'text',
	DATE = 'date',
	DIMENSION = 'dimension'
}
